import config from 'config.js';
import { isDemo } from 'helpers/utility';
import storeObject from 'redux/storeDeclaration';

const { baseUrl, oauthUrl, posloviBaseUrl, poslonautBaseUrl, wwwHrlabUrl, apiUrl } = config;

const isEng = () => {
  const store = storeObject.getStore();
  const state = store.getState();
  const { LanguageSwitcher } = state;
  const { locale } = LanguageSwitcher.get('language');
  return locale === 'en';
};

const urlNormalizeString = (text) => {
  if (typeof text !== 'string') {
    return text;
  }
  return text
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/,+|-+|\s+|\/+/g, '-')
    .replace(/-+/g, '-')
    .toLowerCase();
};

const links = {
  newJob: {
    url: isDemo() ? '#' : `${baseUrl}/ats-prijave/new`,
  },
  jobList: {
    url: `${baseUrl}/ats-prijave`,
    pattern: `${baseUrl}/ats-prijave`,
  },
  dashboard: {
    url: `${baseUrl}/dashboard`,
    pattern: `${baseUrl}/dashboard`,
  },
  preselectionTemplates: {
    url: `${baseUrl}/sabloni/pitanja`,
    pattern: `${baseUrl}/sabloni/pitanja`,
  },
  projects: () => ({
    url: `${baseUrl}/ats-prijave`,
    pattern: `${baseUrl}/ats-prijave`,
  }),
  statistics: (projectId) => ({
    url: `${baseUrl}/ats-prijave/statistike${projectId ? `/${projectId}` : ''}`,
    pattern: `${baseUrl}/ats-prijave/statistike`,
    patternProject: `${baseUrl}/ats-prijave/statistike/:jobId`,
  }),
  projectStatistics: (projectId) => ({
    url: `${baseUrl}/ats-prijave/pozicija/${projectId}/statistike`,
    pattern: `${baseUrl}/ats-prijave/pozicija/:projectId(\\d+)/statistike`,
  }),
  job: (jobId) => ({
    url: `${baseUrl}/ats-prijave/${jobId}`,
    pattern: `${baseUrl}/ats-prijave/:jobId`,
    redirectPattern: `${baseUrl}/ats-prijave/:jobId([0-9]+)/:applicationId([0-9]+)?`,
  }),
  project: (projectId) => ({
    url: `${baseUrl}/ats-prijave/pozicija/${projectId}`,
    pattern: `${baseUrl}/ats-prijave/pozicija/:projectId`,
  }),
  jobSettings: (projectId, jobId) => ({
    url: `${baseUrl}/ats-prijave/pozicija/${projectId}/podesavanje-oglasa/${jobId}`,
    pattern: `${baseUrl}/ats-prijave/pozicija/:projectId(\\d+)/podesavanje-oglasa/:jobId([0-9]+)`,
  }),
  applications: {
    pattern: `${baseUrl}/ats-prijave/pozicija/:projectId([0-9]+)/:applicationId([0-9]+)?`,
  },
  application: (projectId, applicationId) => ({
    url: `${baseUrl}/ats-prijave/pozicija/${projectId}/${applicationId}`,
    pattern: `${baseUrl}/ats-prijave/pozicija/:projectId(\\d+)/:applicationId?`,
    singleApplicationPattern: `${baseUrl}/ats-prijave/pozicija/:projectId(\\d+)/:applicationId`,
  }),
  selection: (projectId, applicationId) => ({
    url: `${baseUrl}/ats-prijave/selekcije/${projectId}${applicationId ? `/${applicationId}` : ''}`,
    pattern: `${baseUrl}/ats-prijave/selekcije/:projectId([0-9]+)/:applicationId([0-9]+)?`,
    boardPattern: `${baseUrl}/ats-prijave/selekcije/:projectId([0-9]+)`,
  }),
  teams: {
    url: `${baseUrl}/podesavanja/timski-rad`,
    pattern: `${baseUrl}/podesavanja/timski-rad`,
  },
  billing: {
    url: `${baseUrl}/fakture`,
    pattern: `${baseUrl}/fakture`,
  },
  billingSettings: {
    url: `${baseUrl}/naplata`,
    pattern: `${baseUrl}/naplata`,
  },
  allApplications: {
    url: `${baseUrl}/ats-sve-prijave`,
    pattern: `${baseUrl}/ats-sve-prijave`,
  },
  settings: {
    url: `${baseUrl}/podesavanja`,
    pattern: `${baseUrl}/podesavanja`,
  },
  integrations: {
    url: `${baseUrl}/integracije`,
    pattern: `${baseUrl}/integracije`,
  },
  newProfile: () => ({
    url: `${baseUrl}/moj-profil`,
    pattern: `${baseUrl}/moj-profil`,
    promo: `${posloviBaseUrl}/poslodavci/moj-profil?designed_force=1`,
    hrBrending: `${posloviBaseUrl}/poslodavci/moj-profil?b_force=1`,
    editor: `${posloviBaseUrl}/poslodavci/moj-profil`,
  }),
  profileEditor: (profileId) => ({
    url: `${baseUrl}/moj-profil/${profileId}`,
    pattern: `${baseUrl}/moj-profil/:profileId([0-9]+)`,
  }),
  oauth: (params) => ({
    /* eslint-disable */
    authorize: `${oauthUrl}/authorize?response_type=code&client_id=ats&scope=identity ads:read ads:write applications:read applications:write email_templates:read email_templates:write employer_profile:read employer_profile:write password:write&redirect_uri=${
      /* eslint-enable */
      location.origin // eslint-disable-line
    }${baseUrl}/validate`, // eslint-disable-line
    logout: `${oauthUrl}/logout`,
    /* eslint-disable */
    requestLogin: `${oauthUrl}/authorize?response_type=code&client_id=ats&scope=identity ads:read ads:write applications:read applications:write email_templates:read email_templates:write employer_profile:read employer_profile:write password:write&redirect_uri=${
      /* eslint-enable */
      location.origin // eslint-disable-line
    }${baseUrl}/validate`, // eslint-disable-line,
    login: `${oauthUrl}/login`,
    changePassword: `${oauthUrl}/changePassword?redirectTo=${location.href}`, // eslint-disable-line
    register: `${oauthUrl}/register${
      params && params.redirectUri ? `?redirect_uri=${params.redirectUri}` : ''
    }`,
  }),
  jobPosting: (uid) => ({
    url: `${posloviBaseUrl}/poslodavci/formular-za-placeni-oglas${uid ? `/${uid}` : ''}`,
  }),
  poslonautJobPosting: () => ({
    url: `${poslonautBaseUrl}/naruci-oglas`,
  }),
  poslonautJobPreview: ({ jobTitle, jobId }) => ({
    url: `${poslonautBaseUrl}/posao/${urlNormalizeString(jobTitle)}/${jobId}`,
  }),
  invite: () => ({
    verify: `${baseUrl}/invite/verify`,
    confirmAccessRequest: `/invite/confirm_access_request`,
  }),
  /**
   * @deprecated this route is not used anymore, use myPackages for package summery
   */
  packages: () => ({
    url: `${baseUrl}/stanje-zakupljenog-paketa`,
    pattern: `${baseUrl}/stanje-zakupljenog-paketa`,
  }),
  /**
   * @deprecated this route is not used anymore, use packagesAdOrder for ad packages
   */
  packagesCombo: () => ({
    url: `${baseUrl}/stanje-zakupljenog-paketa?form_ad_placement_type=multiple`,
    pattern: `${baseUrl}/stanje-zakupljenog-paketa?form_ad_placement_type=multiple`,
  }),
  projectJobOrderReceipts: (projectId) => ({
    pattern: `${baseUrl}/pregled-narucenih-oglasa/:projectId`,
    url: `${baseUrl}/pregled-narucenih-oglasa/${projectId}`,
  }),
  jobOrderReceipts: (receiptId) => ({
    pattern: `${baseUrl}/pregled-narucenog-oglasa/:receiptId`,
    url: `${baseUrl}/pregled-narucenog-oglasa/${receiptId}`,
  }),
  posloviBaseUrl: () => ({
    url: posloviBaseUrl,
  }),
  fbPromo: () => ({
    url: `${wwwHrlabUrl}${isEng() ? '/en' : '/sr'}/promocija-oglasa-na-fejsbuku/`,
  }),
  eb: () => ({
    url: `${wwwHrlabUrl}${isEng() ? '/en' : '/sr'}/eb-studio`,
  }),
  tk: () => ({
    url: `${wwwHrlabUrl}${isEng() ? '/en' : '/sr'}/targetiranje-kandidata`,
  }),
  jobSubmission: (hash, step) => ({
    pattern: `${baseUrl}/formular-za-placeni-oglas/:hash?/:step?`,
    createPattern: `${baseUrl}/formular-za-placeni-oglas-kreiraj`,
    url: `${baseUrl}/formular-za-placeni-oglas${hash ? `/${hash}` : ''}${step ? `/${step}` : ''}`,
  }),
  jobRenew: (jobId, projectId) => ({
    pattern: `${baseUrl}/ponovno-aktiviranje-oglasa/:jobId([0-9]+)/:projectId([0-9]+)?`,
    url: `${baseUrl}/ponovno-aktiviranje-oglasa/${jobId}${projectId ? `/${projectId}` : ''}`,
  }),
  payments: () => ({
    pattern: `${baseUrl}/transaction`,
    url: `${baseUrl}/transaction`,
  }),
  jobActivated: () => ({
    pattern: `${baseUrl}/ats-prijave/:jobId([0-9]+)/activated`,
  }),
  onlineInterviews: () => ({
    pattern: `${baseUrl}/online-intervju`,
    url: `${baseUrl}/online-intervju`,
  }),
  crm: (companyId) => ({
    url: `https://crm-poslovi.infostud.com/poslodavac/${companyId}`,
  }),
  blackFriday: () => ({
    url: 'https://www.hrlab.rs/sr/hr-blog/novosti/planetarno-popularni-crni-petak-stize-i-kod-nas',
  }),
  helloworldizer: (jobLink) =>
    jobLink.replace('https://poslovi.infostud.com/', 'https://www.helloworld.rs/'),
  loyaltyReport: () => ({
    pattern: `${baseUrl}/izvestaj-lojalnosti`,
    url: `${baseUrl}/izvestaj-lojalnosti`,
  }),
  loyaltyClub: () => ({
    url: `${baseUrl}/klub-lojalnosti`,
    pattern: `${baseUrl}/klub-lojalnosti`,
  }),
  activateJob: () => ({
    pattern: `${baseUrl}/aktiviraj_oglas/:jobId([0-9]+)/:hash`,
  }),
  /**
   * Public, unauthenticated view of a single shared application.
   *
   * Not registered in router.jsx: nginx serves this route from a separate HTML entry
   * (share.html), so it never reaches the app router or RestrictedRoute.
   */
  sharedApplication: (token) => ({
    url: `${baseUrl}/deljena-prijava/${token}`,
    pattern: `${baseUrl}/deljena-prijava/:token`,
  }),
  startujAdForm: () => ({
    url: 'https://startuj.infostud.com/postavite-oglas',
  }),
  /**
   *
   * @param {Object} params
   * @param {number} [params.projectId]
   * @param {number} [params.adType]
   * @param {number} [params.siteVisibility]
   * @param {15|30} [params.duration]
   * @returns {{url: string}}
   */
  jobIncompleteCreate: (params) => {
    const queryString = new URLSearchParams(params);
    return {
      url: `${baseUrl}/formular-za-placeni-oglas-kreiraj?${queryString.toString()}`,
    };
  },
  candidateSearch: () => ({
    pattern: `${baseUrl}/baza-kandidata`,
    url: `${baseUrl}/baza-kandidata`,
  }),
  /**
   * @deprecated this route is not used anymore, use candidateSearchPackages for cs packages
   */
  candidateDatabasePackages: () => ({
    url: `${baseUrl}/baza-kandidata/paketi`,
    pattern: `${baseUrl}/baza-kandidata/paketi`,
  }),
  candidateProfilePhoto: (relativePath) => ({
    url: `${apiUrl}${relativePath}`,
  }),
  /**
   * @deprecated this route is not used anymore, use socialPromotionPackages for sp packages
   */
  socialPostingPackages: () => ({
    url: `${baseUrl}/stanje-zakupljenog-paketa/promocija-oglasa`,
    pattern: `${baseUrl}/stanje-zakupljenog-paketa/promocija-oglasa`,
  }),
  /**
   * @deprecated this route and package type is not used anymore
   */
  bundlePackages: () => ({
    url: `${baseUrl}/stanje-zakupljenog-paketa/biznis-plus`,
    pattern: `${baseUrl}/stanje-zakupljenog-paketa/biznis-plus`,
  }),
  publicTransactionReturn: () => ({
    pattern: `${baseUrl}/transaction-return`,
  }),
  reports: {
    baseReports: () => ({
      url: `${baseUrl}/izvestaji`,
      pattern: `${baseUrl}/izvestaji`,
    }),
    posloviProfileReport: () => ({
      url: `${baseUrl}/izvestaji/izvestaj-profila-poslovi`,
      pattern: `${baseUrl}/izvestaji/izvestaj-profila-poslovi`,
    }),
    hwProfileReport: () => ({
      url: `${baseUrl}/izvestaji/izvestaj-profila-helloworld`,
      pattern: `${baseUrl}/izvestaji/izvestaj-profila-helloworld`,
    }),
    hrReport: () => ({
      url: `${baseUrl}/izvestaji/hr-izvestaj`,
      pattern: `${baseUrl}/izvestaji/hr-izvestaj`,
    }),
  },
  adSurvey: (jobId) => ({
    url: `${baseUrl}/anketa/zadovoljstvo-konkursom/${jobId}`,
    pattern: `${baseUrl}/anketa/zadovoljstvo-konkursom/:jobId([0-9]+)`,
  }),
  incompleteOrderSurvey: (incompleteJobId) => ({
    url: `${baseUrl}/anketa/nedovrseni-formular/${incompleteJobId}`,
    pattern: `${baseUrl}/anketa/nedovrseni-formular/:incompleteJobId([0-9]+)`,
  }),
  newYearExtend: () => ({
    pattern: `${baseUrl}/novogodisnji-produzetak/:jobId([0-9]+)/:hash`,
  }),
  genericSurvey: () => ({
    pattern: `${baseUrl}/upitnik`,
  }),
  welcomePackage: () => ({
    url: `${baseUrl}/prva-kupovina`,
    pattern: `${baseUrl}/prva-kupovina`,
  }),
  smartSortSubscriptionPage: () => ({
    url: `${baseUrl}/smart-sort`,
    pattern: `${baseUrl}/smart-sort`,
  }),
  calendarPage: () => ({
    url: `${baseUrl}/kalendar`,
    pattern: `${baseUrl}/kalendar`,
  }),
  servicePackages: {
    packagesBaseUrl: {
      url: `${baseUrl}/ponuda-paketa`,
      pattern: `${baseUrl}/ponuda-paketa`,
    },
    packagesPageSelector: () => ({
      url: `${baseUrl}/paketi-usluga`,
      pattern: `${baseUrl}/paketi-usluga`,
    }),
    myPackages: (category) => ({
      url: category ? `${baseUrl}/moji-paketi?category=${category}` : `${baseUrl}/moji-paketi`,
      pattern: `${baseUrl}/moji-paketi`,
    }),
    jobPackages: () => ({
      url: `${baseUrl}/ponuda-paketa/paket-oglasa`,
      pattern: `${baseUrl}/ponuda-paketa/paket-oglasa`,
    }),
    socialPromotionPackages: () => ({
      url: `${baseUrl}/ponuda-paketa/paket-promocija`,
      pattern: `${baseUrl}/ponuda-paketa/paket-promocija`,
    }),
    candidateSearchPackages: () => ({
      url: `${baseUrl}/ponuda-paketa/paket-baza-kandidata`,
      pattern: `${baseUrl}/ponuda-paketa/paket-baza-kandidata`,
    }),
    highlightedAdPackages: () => ({
      url: `${baseUrl}/ponuda-paketa/paket-plavih-oglasa`,
      pattern: `${baseUrl}/ponuda-paketa/paket-plavih-oglasa`,
    }),
    topResultPackages: () => ({
      url: `${baseUrl}/ponuda-paketa/paket-oglasa-u-vrhu`,
      pattern: `${baseUrl}/ponuda-paketa/paket-oglasa-u-vrhu`,
    }),
    payment: () => ({
      url: `${baseUrl}/ponuda-paketa/vasa-porudzbina`,
      pattern: `${baseUrl}/ponuda-paketa/vasa-porudzbina`,
    }),
  },
};

export default links;
